<template>
  <div class="container py-3">
    <div class="d-flex justify-content-end mb-3">
      <ol class="breadcrumb text-align-right">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item"><a href="/news-and-events">News & Events</a></li>
        <li class="breadcrumb-item active text-truncate" style="max-width: 300px;">{{ newsAndAnnouncementsData.title }}</li>
      </ol>
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <div v-if="canEditCms">
        <router-link :to="{ name: 'news-and-announcements-edit', params: {id: newsAndAnnouncementsData.id}}">
          <i class="fa fa-edit edit-icon" v-b-tooltip.hover title="Edit"></i>
        </router-link>
      </div>
    </div>
    <div class="text-left bold-24">
      {{ newsAndAnnouncementsData.title }}
    </div>
    <div v-if="checkNullAndEmptyValues(newsAndAnnouncementsData.post_date)" class="text-muted medium-16 mt-1 mb-2">
      {{moment(newsAndAnnouncementsData.post_date, 'YYYY-MM-DD').format('MMMM Do, YYYY')}}
    </div>
    <b-badge variant="secondary" class="mr-1 mb-2" v-for="(tag, index) in newsAndAnnouncementsData.tag_names" :key="index">
      <span class="regular-12 typo-color-white">{{tag}}</span>
    </b-badge>

    <div>
      <div class="float-md-left pr-3 thumbnail_left_float">
        <news-and-announcements-thumbnail-section :data="newsAndAnnouncementsData" />
      </div>
      <div v-if="newsAndAnnouncementsData.post_content" class="mt-3 custom-html-image custom-html-text regular-16" v-html="newsAndAnnouncementsData.post_content" style="overflow: unset;" />
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"
import NewsAndAnnouncementsThumbnailSection from "@/components/NewsAndEvent/NewsAndAnnouncements/NewsAndAnnouncementsThumbnailSection.vue"

export default {
	name: "NewsAndAnnouncementPermalinkFeaturedSection",
	metaInfo() {
		return {
			title: this.newsAndAnnouncementsData ? this.newsAndAnnouncementsData.title : "SLMath",
		}
	},
	mixins: [mixin],
	props: ["newsAndAnnouncementsData"],
	components: {
		NewsAndAnnouncementsThumbnailSection,
	},
	computed: {
		...mapGetters(["canEditCms"]),
	},
	updated() {
		MathJax.typeset()
	},
}
</script>

<style lang="scss">
.thumbnail_left_float {
  width: 30%;
  @media (max-width: 992px) {
    width: 40%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
  img {
    height: auto !important;
  }
}
</style>
